(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('MainSeriesDetailController', MainSeriesDetailController);

//    MainSeriesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'MainSeries'];
//
//    function MainSeriesDetailController($scope, $rootScope, $stateParams, DataUtils, MainSeries) {
//    	var vm = this;
//
//        vm.mainSeries1 = [{stockName:'Pru Laza',productCode:'HSCT2', productName:'Biên nhận hồ sơ',quantityInventory:'20000',seriesNum:'324245-34634636',reasonModify:'Điều chính cuối kỳ',status:'1'},
//                          {stockName:'Pru Laza',productCode:'HSCT2', productName:'Phiếu chi',quantityInventory:'23423',seriesNum:'324245-34634636',reasonModify:'Điều chính cuối kỳ',status:'1'},
//                          {stockName:'Pru Laza',productCode:'HSCT3', productName:'Hồ sơ yêu cầu bảo hiểm',quantityInventory:'233',seriesNum:'324245-34634636',reasonModify:'Điều chính cuối kỳ',status:'1'},
//                          {stockName:'Pru Laza',productCode:'HSCT4', productName:'Biên nhận hồ sơ',quantityInventory:'55',seriesNum:'324245-34634636;324245-34634636;',reasonModify:'Điều chính cuối kỳ',status:'1'},
//                          {stockName:'Pru Laza',productCode:'HSCT5', productName:'Biên nhận hồ sơ',quantityInventory:'2342',seriesNum:'324245-34634636;324245-34634636;',reasonModify:'Điều chính cuối kỳ',status:'1'}];
//        vm.mainSeries = vm.mainSeries1[0];
    MainSeriesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils','MainSeries'];

    function MainSeriesDetailController($scope, $rootScope, $stateParams, DataUtils, entity, MainSeries) {
        var vm = this;

        vm.mainSeries = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        if(vm.mainSeries.status == 1){
        	vm.mainSeries.statusName = 'Đang hoạt động'
        }else{
        	vm.mainSeries.statusName = 'Ngừng hoạt động'
        }
        var unsubscribe = $rootScope.$on('setupApp:mainSeriesUpdate', function(event, result) {
            vm.mainSeries = result;
            
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
